const ar = {
  nav: {
    features: 'المميزات',
    pricing: 'الأسعار',
    signIn: 'تسجيل الدخول',
    getStarted: 'ابدأ الآن',
    home: 'الرئيسية',
    dashboard: 'لوحة التحكم',
    quotations: 'عروض الأسعار',
    invoices: 'الفواتير',
    receipts: 'الإيصالات',
    bills: 'فواتير الموردين',
    documents: 'كل المستندات',
    docGroup: 'المستندات',
    newDoc: 'جديد',
    support: 'الدعم',
    supportCases: 'حالات الدعم',
    clients: 'العملاء',
    items: 'الأصناف',
    settings: 'الإعدادات',
    subscription: 'الاشتراك',
    profile: 'الملف الشخصي',
    admin: 'المدير',
    system: 'النظام',
    users: 'المستخدمون',
    userStats: 'إحصائيات المستخدمين',
    finance: 'المالية',
    activity: 'سجل النشاط',
    backups: 'النسخ الاحتياطية',
    changelog: 'سجل الإصدارات',
    signOut: 'تسجيل الخروج',
    viewProfile: 'عرض الملف الشخصي',
    collapse: 'طيّ',
    light: 'فاتح',
    dark: 'داكن',
    full: 'ملء الشاشة',
    exit: 'خروج',
    recurring: 'الفواتير المتكررة',
  },
  hero: {
    eyebrow: 'إدارة المستندات التجارية',
    headline1: 'عروض الأسعار والفواتير',
    headline2: 'والإيصالات.',
    headline3: 'بطريقة احترافية.',
    sub: 'توقف عن العناء مع قوالب Word وجداول البيانات. يوفر لك Invio ملفات PDF مخصصة بعلامتك التجارية، وإدارة العملاء، ودعم العملات المتعددة، وتجربة مجانية لمدة 30 يومًا.',
    ctaPrimary: 'ابدأ تجربة مجانية لمدة 30 يومًا ←',
    ctaSecondary: 'الاطلاع على الأسعار',
    trust: '✓ لا حاجة لبطاقة ائتمان  ·  ✓ يمكنك الإلغاء في أي وقت  ·  ✓ الإعداد في 60 ثانية',
  },
  stats: {
    docTypes: 'أنواع المستندات',
    currencies: 'العملات المدعومة',
    languages: 'اللغات',
    docsPerMo: 'مستندات شهريًا',
    dayTrial: 'يومًا تجريبيًا مجانيًا',
  },
  features: {
    eyebrow: 'المميزات',
    title: 'كل ما تحتاجه لإصدار الفواتير لعملائك',
    sub: 'أداة واحدة لكل مستند تجاري — بدون إضافات أو رسوم مخفية.',
    items: {
      quotations:    { title: 'عروض الأسعار',       desc: 'أرسل عروضًا احترافية وحوّلها إلى فواتير بنقرة واحدة.' },
      invoices:      { title: 'الفواتير',            desc: 'حرّر فواتير لعملائك بترقيم تلقائي وملفات PDF مخصصة بعلامتك التجارية في ثوانٍ.' },
      receipts:      { title: 'الإيصالات',           desc: 'أصدر إيصالات دفع تطابق فاتورتك تمامًا.' },
      bills:         { title: 'فواتير الموردين',    desc: 'تتبع فواتير الموردين جنبًا إلى جنب مع ما تتقاضاه من العملاء.' },
      purchase:      { title: 'أوامر الشراء والتسليم', desc: 'أوامر شراء وتسليم للسلع التي تطلبها أو تشحنها.' },
      credit:        { title: 'إشعارات الائتمان',   desc: 'أصدر استرداداتٍ وتسوياتٍ مع توثيق كامل.' },
      clients:       { title: 'دفتر عناوين العملاء', desc: 'سجلات عملاء قابلة لإعادة الاستخدام تملأ كل مستند تلقائيًا.' },
      multiCurrency: { title: 'عملات متعددة',       desc: '{count} عملة بما في ذلك USD وEUR وMYR وCNY وجميع عملات الجامعة العربية.' },
      export:        { title: 'تصدير PDF وWord',     desc: 'ملفات PDF جاهزة للطباعة وملفات .docx قابلة للتحرير لكل أنواع المستندات.' },
    },
  },
  pricing: {
    eyebrow: 'الأسعار',
    title: 'أسعار بسيطة وشفافة',
    sub: 'ابدأ بتجربة مجانية لمدة 30 يومًا. لا حاجة لبطاقة ائتمان.',
    monthly: 'شهريًا',
    yearly: 'سنويًا',
    perMonth: '/شهر',
    perYear: '/سنة',
    save: 'وفّر {p}٪',
    cta: 'ابدأ التجربة المجانية',
    custom: 'مخصص',
    customPrice: 'تواصل معنا',
    customSub: 'مصمم خصيصًا لفريقك',
    contactUs: 'تواصل معنا',
    plan: {
      monthly: { f1: 'مستندات غير محدودة', f2: 'استخراج العناصر بالذكاء الاصطناعي', f3: 'تصدير PDF وWord', f4: 'إلغاء في أي وقت' },
      yearly:  { f1: 'ما يعادل {amount} شهريًا', f2: 'مستندات غير محدودة', f3: 'استخراج العناصر بالذكاء الاصطناعي', f4: 'تصدير PDF وWord' },
      custom:  { f1: 'ميزات وتكاملات مخصصة', f2: 'خصومات الكميات', f3: 'دعم ذو أولوية', f4: 'حسابات متعددة المستخدمين للفرق' },
    },
  },
  finalCta: {
    title: 'هل أنت مستعد لإرسال أول فاتورة؟',
    sub: 'أنشئ ملف شركتك في 60 ثانية. أصدر أول عرض سعر اليوم.',
    button: 'ابدأ مجانًا ←',
  },
  footer: {
    tagline: 'إدارة احترافية للمستندات التجارية للفرق الصغيرة.',
    product: 'المنتج',
    account: 'الحساب',
    contact: 'تواصل معنا',
    createAccount: 'إنشاء حساب',
    legal: 'قانوني',
    terms: 'شروط الخدمة',
    privacy: 'سياسة الخصوصية',
    refund: 'سياسة الاسترداد',
    copyright: '© {year} Invio · invio.my',
  },
  banner: {
    verifyEmail: '⚠ يرجى تأكيد بريدك الإلكتروني.',
    weSentLink: 'لقد أرسلنا رابط التأكيد إلى',
    resend: 'إعادة إرسال البريد',
    sending: 'جاري الإرسال…',
    deactivated: 'تم تعطيل حسابك. يرجى التواصل مع المسؤول.',
    trialEnded: 'انتهت فترتك التجريبية',
    graceDaysLeft: 'لديك {d} يوم (أيام) من فترة السماح. اشترك لمواصلة استخدام Invio.',
    subscribeNow: 'اشترك الآن',
    paymentFailed: 'فشل الدفع',
    paymentFailedMsg: 'لم نتمكن من الخصم من بطاقتك. حدِّث طريقة الدفع خلال {d} يوم (أيام) للاحتفاظ بالوصول.',
    updatePayment: 'تحديث طريقة الدفع',
    trialExtended: 'تم تمديد فترتك التجريبية',
    trialExtendedBy: 'أضفنا {d} يومًا إضافيًا. تنتهي فترتك التجريبية الآن في {date}.',
    dismiss: 'إغلاق',
  },
  emailPrefs: {
    title: 'إشعارات البريد الإلكتروني',
    subtitle: 'اختر الرسائل الاختيارية التي نرسلها إليك.',
    securityAlerts: 'تنبيهات تسجيل الدخول الجديد',
    securityAlertsDesc: 'أرسل لي بريداً عند تسجيل الدخول إلى حسابي من جهاز أو متصفح جديد.',
    announcements: 'تحديثات المنتج',
    announcementsDesc: 'أخبار من حين لآخر عن ميزات وتحسينات Invio الجديدة.',
    transactionalNote: 'الرسائل الأساسية — التحقق، وإعادة تعيين كلمة المرور، ورموز الأمان، والفوترة وإشعارات التجربة — تُرسل دائماً.',
  },
  sessions: {
    title: 'الجلسات النشطة',
    subtitle: 'الأجهزة المسجّلة الدخول إلى حسابك — سجّل خروج أي جهاز لا تعرفه.',
    activeDevices: 'الأجهزة المسجّلة الدخول',
    none: 'لا توجد جلسات نشطة أخرى.',
    thisDevice: 'هذا الجهاز',
    lastActive: 'آخر نشاط {when}',
    revoke: 'تسجيل الخروج',
    signOutOthers: 'تسجيل الخروج من جميع الأجهزة الأخرى',
    now: 'الآن',
    minAgo: 'قبل {n} دقيقة',
    hrAgo: 'قبل {n} ساعة',
  },
  twofa: {
    title: 'التحقق بخطوتين',
    enterAppCode: 'أدخل الرمز المكوَّن من 6 أرقام من تطبيق المصادقة.',
    enterEmailCode: 'أرسلنا لك رمزاً من 6 أرقام عبر البريد الإلكتروني. أدخله أدناه.',
    trustDevice: "لا تطلب مرة أخرى على هذا الجهاز لمدة 30 يوماً",
    verify: 'تحقق',
    resend: 'إعادة إرسال الرمز',
    codeSent: 'تم إرسال الرمز ✓',
    section: 'المصادقة الثنائية (2FA)',
    sectionSub: 'خطوة ثانية عند تسجيل الدخول تحمي حسابك حتى لو تسربت كلمة المرور.',
    statusOff: 'معطّلة',
    statusApp: 'مفعّلة — تطبيق مصادقة',
    statusEmail: 'مفعّلة — رموز البريد الإلكتروني',
    useApp: 'استخدام تطبيق مصادقة',
    useEmail: 'استخدام رموز البريد الإلكتروني',
    scanQr: 'امسح رمز QR هذا بتطبيق Google Authenticator أو Microsoft Authenticator أو Authy أو أي تطبيق TOTP.',
    manualKey: 'أو أدخل هذا المفتاح يدوياً:',
    thenEnter: 'ثم أدخل الرمز المكوَّن من 6 أرقام الذي يعرضه التطبيق:',
    activate: 'تفعيل',
    emailSent: 'أرسلنا رمزاً من 6 أرقام إلى {email}. أدخله لتفعيل رموز البريد الإلكتروني.',
    enabled: 'تم تفعيل المصادقة الثنائية',
    disabled: 'تم إيقاف المصادقة الثنائية',
    activeApp: 'يتطلب تسجيل الدخول رمزاً من تطبيق المصادقة.',
    activeEmail: 'يتطلب تسجيل الدخول رمزاً يُرسل إلى بريدك الإلكتروني.',
    turnOff: 'إيقاف',
    confirmPassword: 'أدخل كلمة المرور لإيقاف المصادقة الثنائية:',
  },
  auth: {
    signInTab: 'تسجيل الدخول',
    registerTab: 'إنشاء حساب',
    welcomeBack: 'مرحبًا بعودتك',
    createAccountTitle: 'أنشئ حسابك',
    signInSub: 'سجّل الدخول لإدارة مستنداتك التجارية.',
    registerSub: 'ابدأ مع Invio اليوم.',
    fullName: 'الاسم الكامل',
    fullNamePlaceholder: 'اسمك',
    email: 'البريد الإلكتروني',
    emailPlaceholder: 'you@example.com',
    password: 'كلمة المرور',
    passwordPlaceholder: '••••••••',
    rememberMe: 'تذكرني',
    forgotPassword: 'نسيت كلمة المرور؟',
    showPassword: 'إظهار كلمة المرور',
    hidePassword: 'إخفاء كلمة المرور',
    pleaseWait: 'يرجى الانتظار…',
    signInBtn: 'تسجيل الدخول',
    createAccountBtn: 'إنشاء الحساب',
    invalidCredentials: 'البريد الإلكتروني أو كلمة المرور غير صحيحة.',
    weakPassword: 'كلمة المرور لا تستوفي متطلبات الأمان.',
    backToSignIn: 'العودة إلى تسجيل الدخول',
    resetTitle: 'إعادة تعيين كلمة المرور',
    resetIntro: 'أدخل البريد الإلكتروني المرتبط بحسابك وسنرسل لك رابط إعادة التعيين.',
    sendResetLink: 'إرسال رابط إعادة التعيين',
    checkInbox: 'تحقق من بريدك الوارد',
    ifRegistered: 'إذا كان {email} مسجلاً، فقد تم إرسال رابط إعادة تعيين كلمة المرور.',
    backToSignInBtn: 'العودة إلى تسجيل الدخول',
    resetSendFailed: 'تعذّر إرسال رابط إعادة التعيين. يرجى المحاولة مرة أخرى.',
    resetSpamHint: 'تنتهي صلاحية الرابط خلال ساعة واحدة. إذا لم تصلك الرسالة خلال بضع دقائق، فتحقق من مجلد الرسائل غير المرغوب فيها.',
    agree: 'بإنشاء حساب، فإنك توافق على {terms} و{privacy}.',
    tagline: 'إدارة احترافية للمستندات التجارية — عروض الأسعار والفواتير والإيصالات والمزيد.',
    feature1: 'عروض الأسعار والفواتير',
    feature2: 'إدارة العملاء',
    feature3: 'تصدير PDF وWord',
  },
  docType: {
    quotation: 'عرض سعر', invoice: 'فاتورة', bill: 'فاتورة مورد', receipt: 'إيصال',
    purchase_order: 'أمر شراء', delivery_order: 'أمر تسليم',
    credit_note: 'إشعار دائن', statement: 'كشف حساب',
  },
  status: {
    draft: 'مسودة', sent: 'مرسل', accepted: 'مقبول', rejected: 'مرفوض',
    paid: 'مدفوع', overdue: 'متأخر', cancelled: 'ملغى',
    partial: 'مدفوع جزئيًا',
  },
  doc: {
    description: 'الوصف', qty: 'الكمية', unitPrice: 'سعر الوحدة', amount: 'المبلغ',
    subtotal: 'المجموع الفرعي', discount: 'الخصم', tax: 'الضريبة', total: 'الإجمالي',
  },
  docs: {
    allDocuments: 'جميع المستندات',
    titlePlural: {
      quotation: 'عروض الأسعار', invoice: 'الفواتير', bill: 'فواتير الموردين', receipt: 'الإيصالات',
      purchase_order: 'أوامر الشراء', delivery_order: 'أوامر التسليم',
      credit_note: 'الإشعارات الدائنة', statement: 'كشوف الحساب',
    },
    count: '{n} مستند',
    document: 'مستند',
    newType: '{type} جديد',
    searchPlaceholder: 'ابحث بالرقم أو العميل…',
    allTypes: 'جميع الأنواع',
    allStatus: 'جميع الحالات',
    noneFound: 'لم يتم العثور على {title}',
    createFirst: 'أنشئ أول {type} لك',
    thType: 'النوع', thNumber: 'الرقم', thClient: 'العميل', thDate: 'التاريخ',
    thAmount: 'المبلغ', thStatus: 'الحالة', thActions: 'الإجراءات',
    view: 'عرض', edit: 'تعديل', copy: 'نسخ', del: 'حذف',
    confirmDelete: 'هل تريد حذف هذا المستند؟',
    duplicateFailed: 'تعذر نسخ المستند',
  },
  editor: {
    editTitle: 'تعديل {type}',
    newTitle: '{type} جديد',
    saveChanges: 'حفظ التغييرات',
    createDocument: 'إنشاء مستند',
    documentDetails: 'تفاصيل المستند',
    documentType: 'نوع المستند',
    status: 'الحالة',
    issueDate: 'تاريخ الإصدار',
    validUntil: 'صالح حتى',
    dueDate: 'تاريخ الاستحقاق',
    referenceNumber: 'الرقم المرجعي',
    auto: 'تلقائي',
    manual: 'يدوي',
    autoGenerated: 'سيتم إنشاؤه تلقائيًا (مثل QT-2026-0001)',
    supplierBillTo: 'المورد وجهة الفوترة',
    client: 'العميل',
    supplierName: 'اسم المورد',
    supplierNamePh: 'اسم شركة المورد',
    supplierAddress: 'عنوان المورد',
    supplierAddressPh: 'عنوان المورد',
    billToClient: 'فوترة إلى (العميل)',
    selectClientPh: 'اختر عميلًا…',
    selectClient: 'اختر العميل',
    noClient: '— بدون عميل —',
    addClient: '+ إضافة عميل',
    items: 'البنود',
    titleOptional: 'العنوان (اختياري)',
    titlePh: 'مثال: مشروع ABC – المرحلة 1',
    hidePrices: 'إخفاء الأسعار في أمر التسليم هذا',
    hidePricesHint: 'يزيل عمودي سعر الوحدة والمبلغ وجميع الإجماليات من ملفي PDF وWord. تبقى الأسعار المدخلة محفوظة، وإلغاء التحديد يعيد إظهارها.',
    itemDescriptionPh: 'وصف البند',
    saveAsItem: 'حفظ كبند قابل لإعادة الاستخدام',
    removeRow: 'حذف الصف',
    addItem: '+ إضافة بند',
    fromSaved: 'من المحفوظات',
    notesTerms: 'الملاحظات والشروط',
    notesLabel: 'ملاحظات (يراها العميل)',
    notesPh: 'شكرًا لتعاملكم معنا…',
    termsLabel: 'الشروط والأحكام',
    termsPh: 'شروط الدفع، شروط التسليم…',
    includeSignature: 'تضمين خانة التوقيع في PDF',
    currencyPricing: 'العملة والتسعير',
    currency: 'العملة',
    taxRatePct: 'نسبة الضريبة (%)',
    discountType: 'نوع الخصم',
    fixed: 'ثابت',
    percent: 'نسبة مئوية',
    discountValue: 'قيمة الخصم',
    summary: 'الملخص',
    pricesHiddenEditorNote: 'الأسعار مخفية في أمر التسليم هذا — الأرقام أدناه محفوظة لكنها لن تظهر في ملف PDF أو Word.',
    generating: 'جارٍ الإنشاء…',
    previewPdf: 'معاينة / طباعة PDF',
    downloadWord: 'تنزيل Word (.docx)',
    pickSavedItem: 'اختر بندًا محفوظًا',
    noSavedItems: 'لا توجد بنود محفوظة بعد.',
    manageItems: 'إدارة البنود',
    searchItemsPh: 'ابحث في البنود…',
    itemNeedsDescription: 'البند {n} يحتاج إلى وصف',
    docUpdated: 'تم تحديث المستند!',
    docCreated: 'تم إنشاء المستند!',
    errorSaving: 'خطأ أثناء الحفظ',
    pdfFailed: 'تعذر إنشاء PDF',
    wordFailed: 'تعذر إنشاء ملف Word',
    addDescriptionFirst: 'أضف وصفًا أولاً',
    savedToLibrary: 'تم الحفظ في مكتبة البنود',
    couldNotSaveItem: 'تعذر حفظ البند',
  },
  docView: {
    back: 'رجوع',
    issuedOn: 'صدر في {date}',
    statusUpdated: 'تم تحديث الحالة إلى {s}',
    converted: 'تم التحويل إلى {t}!',
    duplicated: 'تم نسخ المستند!',
    deleteConfirm: 'هل تريد حذف هذا المستند نهائيًا؟',
    notFound: 'المستند غير موجود.',
    from: 'من',
    supplier: 'المورد',
    billedTo: 'فوترة إلى',
    updateStatus: 'تحديث الحالة',
    dates: 'التواريخ',
    linkedDocument: 'مستند مرتبط',
    paymentDetails: 'تفاصيل الدفع',
    bank: 'البنك',
    account: 'الحساب',
    name: 'الاسم',
    notes: 'ملاحظات',
    terms: 'الشروط والأحكام',
    pricesHiddenView: 'الأسعار مخفية في أمر التسليم هذا.',
    convertDocument: 'تحويل المستند',
    convertIntro: 'حوِّل {n} إلى نوع مستند جديد. سيتم تحديد المستند الأصلي كمقبول.',
    convertTo: 'تحويل إلى',
    convert: 'تحويل',
    duplicate: 'نسخ',
  },
  clients: {
    title: 'العملاء',
    count: '{n} عميل',
    addClient: 'إضافة عميل',
    empty: 'لا يوجد عملاء بعد. أضف عميلك الأول للبدء.',
    editClient: 'تعديل العميل',
    fullName: 'الاسم الكامل *',
    company: 'الشركة',
    email: 'البريد الإلكتروني',
    phone: 'الهاتف',
    address: 'العنوان',
    city: 'المدينة',
    notes: 'ملاحظات',
    notesPh: 'أي ملاحظات حول هذا العميل…',
    updated: 'تم تحديث العميل!',
    added: 'تمت إضافة العميل!',
    deleted: 'تم حذف العميل',
    confirmDelete: 'هل تريد حذف هذا العميل؟',
  },
  items: {
    title: 'الأصناف',
    count: '{n} صنف محفوظ',
    importBtn: 'استيراد من مستند',
    addItem: 'إضافة صنف',
    searchPh: 'ابحث حسب الوصف أو SKU أو المورّد أو العلامة التجارية أو الفئة…',
    empty: 'لا توجد أصناف محفوظة بعد. أضف منتجات أو خدمات قابلة لإعادة الاستخدام لتسريع إنشاء المستندات.',
    noMatch: 'لا توجد أصناف تطابق "{q}".',
    unitPrice: 'سعر الوحدة',
    unit: 'الوحدة',
    inStock: 'في المخزون',
    supplier: 'المورّد',
    editItem: 'تعديل الصنف',
    description: 'الوصف *',
    descriptionPh: 'باقة تصميم موقع إلكتروني',
    unitPriceLabel: 'سعر الوحدة ({s})',
    costPriceLabel: 'سعر التكلفة ({s})',
    taxRate: 'نسبة الضريبة (%)',
    unitLabel: 'الوحدة',
    unitPh: 'ساعة، قطعة، يوم…',
    category: 'الفئة',
    categoryPh: 'خدمة، منتج…',
    stockQty: 'كمية المخزون',
    sku: 'SKU',
    skuPh: 'رمز المنتج',
    barcode: 'الباركود',
    barcodePh: 'UPC / EAN',
    brand: 'العلامة التجارية',
    notes: 'ملاحظات',
    notesPh: 'أي ملاحظات داخلية حول هذا الصنف…',
    updated: 'تم تحديث الصنف!',
    added: 'تمت إضافة الصنف!',
    deleted: 'تم حذف الصنف',
    confirmDelete: 'هل تريد حذف هذا الصنف؟',
    errorSaving: 'خطأ أثناء الحفظ',
    aiPaidOnly: 'استيراد الذكاء الاصطناعي متاح في الخطط المدفوعة. قم بالترقية من صفحة الاشتراك لاستخدامه.',
    importTitle: 'استيراد أصناف من مستند',
    importIntro: 'حمّل ملف PDF أو صورة أو Excel ‏(.xlsx/.xls) أو CSV. سيستخرج الذكاء الاصطناعي (OCR) الأصناف، ثم يمكنك مراجعتها وتعديلها قبل الحفظ.',
    takePhoto: 'التقاط صورة',
    noneDetected: 'لم يتم العثور على أصناف في هذا المستند.',
    extractionFailed: 'فشل الاستخراج.',
    cameraFailed: 'تعذّر تشغيل الكاميرا.',
    foundSelected: 'تم العثور على {n} صنف · {c} محدد',
    selectAll: 'تحديد الكل',
    clear: 'إلغاء التحديد',
    thDescription: 'الوصف', thUnitPrice: 'سعر الوحدة', thCost: 'التكلفة', thUnit: 'الوحدة',
    thSku: 'SKU', thCategory: 'الفئة', thBrand: 'العلامة', thSupplier: 'المورّد',
    thTax: 'الضريبة %', thQty: 'الكمية',
    working: 'جاري العمل…',
    saveCount: 'حفظ {n} صنف',
    selectAtLeastOne: 'حدد صنفًا واحدًا على الأقل',
    imported: 'تم استيراد {n} صنف',
    importFailed: 'فشل الاستيراد',
  },
  profile: {
    title: 'ملفي الشخصي',
    subtitle: 'إدارة تفاصيل حسابك وأمانه',
    accountInfo: 'معلومات الحساب',
    accountInfoSub: 'حدّث اسمك وبريدك الإلكتروني',
    emailChangeHint: 'لأمانك، يتطلب تغيير بريدك الإلكتروني كلمة المرور. سنرسل رابط تأكيد إلى العنوان الجديد — ويظل بريدك الحالي يعمل حتى تؤكّد.',
    emailNeedsPassword: 'أدخل كلمة المرور الحالية لتغيير بريدك الإلكتروني.',
    sendConfirmation: 'إرسال التأكيد',
    emailConfirmSent: 'تم إرسال التأكيد إلى {email}. انقر الرابط هناك لإتمام التغيير — ويظل بريدك الحالي يعمل حتى ذلك الحين.',
    emailPending: 'التغيير إلى {email} قيد الانتظار — تحقق من ذلك البريد للحصول على رابط التأكيد.',
    cancelEmailChange: 'إلغاء تغيير البريد الإلكتروني',
    emailChangeCancelled: 'تم إلغاء تغيير البريد الإلكتروني',
    uploadPhoto: 'رفع صورة',
    changePhoto: 'تغيير الصورة',
    removePhoto: 'إزالة',
    photoUpdated: 'تم تحديث صورة الملف الشخصي',
    photoRemoved: 'تمت إزالة صورة الملف الشخصي',
    photoTooLarge: 'الصورة كبيرة جداً. الرجاء استخدام صورة أقل من 1 ميجابايت.',
    fullName: 'الاسم الكامل',
    fullNamePh: 'اسمك',
    email: 'البريد الإلكتروني',
    updated: 'تم تحديث الملف الشخصي!',
    updateFailed: 'فشل تحديث الملف الشخصي',
    changePassword: 'تغيير كلمة المرور',
    changePasswordSub: 'استخدم كلمة مرور قوية من 6 أحرف على الأقل',
    currentPassword: 'كلمة المرور الحالية',
    newPassword: 'كلمة المرور الجديدة',
    confirmPassword: 'تأكيد كلمة المرور الجديدة',
    noMatch: 'كلمتا المرور غير متطابقتين',
    weakPassword: 'كلمة المرور الجديدة لا تفي بمتطلبات الأمان.',
    changed: 'تم تغيير كلمة المرور بنجاح!',
    changeFailed: 'فشل تغيير كلمة المرور',
    updating: 'جاري التحديث…',
    updatePassword: 'تحديث كلمة المرور',
    session: 'الجلسة',
    sessionSub: 'إدارة جلسة تسجيل الدخول النشطة',
    signedInAs: 'مسجّل الدخول باسم',
    thisDevice: 'هذا الجهاز',
    memberSince: 'عضو منذ',
    protected: 'مفعّلة',
    signOutOf: 'تسجيل الخروج من Invio',
    redirected: 'سيتم توجيهك إلى صفحة تسجيل الدخول.',
    accountType: 'نوع الحساب',
    standard: 'قياسي',
    plan: 'الخطة',
    comingSoon: 'قريبًا',
    photoUpload: 'رفع صورة الملف الشخصي',
    twoFactor: 'المصادقة الثنائية',
    emailNotifications: 'إشعارات البريد الإلكتروني',
    sessionMgmt: 'إدارة الجلسات النشطة',
  },
  settings: {
    title: 'الإعدادات',
    subtitle: 'اضبط ملف شركتك والإعدادات الافتراضية للمستندات',
    saveSettings: 'حفظ الإعدادات',
    saved: 'تم حفظ الإعدادات!',
    companyLogo: 'شعار الشركة',
    preview: 'معاينة',
    uploadImage: 'رفع صورة',
    removeWhiteBg: 'إزالة الخلفية البيضاء',
    remove: 'إزالة',
    logoHeight: 'ارتفاع الشعار (بكسل)',
    previewNote: 'تظهر المعاينة على خلفية داكنة مثل ترويسة ملف PDF.',
    whiteBgRemoved: 'تمت إزالة الخلفية البيضاء — لا تنسَ الحفظ',
    logoProcessFailed: 'تعذّرت معالجة صورة الشعار',
    companyInfo: 'معلومات الشركة',
    companyName: 'اسم الشركة *',
    address: 'العنوان',
    cityState: 'المدينة / الولاية',
    phone: 'الهاتف',
    email: 'البريد الإلكتروني',
    website: 'الموقع الإلكتروني',
    regNo: 'رقم التسجيل',
    taxNo: 'الرقم الضريبي / SST',
    docAppearance: 'مظهر المستندات',
    docAppearanceIntro: 'يُطبّق على كل مستند تنشئه، في ملف PDF وملف Word.',
    templateGallery: 'قالب PDF',
    templateGalleryHint: 'اختر نمطًا مرئيًا لمستندات PDF. يستخدم تنزيل Word دائمًا التخطيط الكلاسيكي.',
    tplClassic: 'كلاسيكي',
    tplMinimal: 'بسيط',
    tplBold: 'جريء',
    tplElegant: 'أنيق',
    tplGradient: 'متدرّج',
    tplSlate: 'فحمي',
    tplSoft: 'ناعم',
    tplStripe: 'شريط',
    tplFrame: 'إطار',
    tplMono: 'أحادي',
    tplSidebar: 'شريط جانبي',
    tplLedger: 'دفتري',
    tplSlim: 'نحيف',
    tplCurve: 'منحني',
    tplDiagonal: 'قطري',
    tplBanner: 'لافتة',
    tplDuo: 'ثنائي',
    tplCards: 'بطاقات',
    tplPop: 'بوب',
    tplRoyal: 'ملكي',
    tplMarker: 'تظليل',
    tplSketch: 'رسم حر',
    tplGhost: 'مفرّغ',
    tplMidnight: 'منتصف الليل',
    colorPresets: 'ألوان جاهزة',
    colorPresetsHint: 'أزواج ألوان بنقرة واحدة، تُطبّق على أي قالب تختاره — ويمكن تعديلها بدقة من الأدوات أدناه.',
    presetNavy: 'كحلي',
    presetSky: 'سماوي',
    presetTeal: 'فيروزي',
    presetEmerald: 'زمردي',
    presetBurgundy: 'خمري',
    presetCrimson: 'قرمزي',
    presetCopper: 'نحاسي',
    presetPlum: 'بنفسجي',
    presetRose: 'وردي',
    presetGraphite: 'جرافيت',
    headerColour: 'لون الترويسة',
    accentColour: 'اللون المميز',
    hexInvalid: 'يلزم رمز سداسي من 6 خانات مثل ‎#1A3C6E — سيُستخدم اللون الافتراضي بدلاً منه.',
    font: 'الخط',
    bodySize: 'حجم نص المتن (بكسل)',
    headerSizePct: 'حجم الترويسة (%)',
    headerTextSizes: 'أحجام نص الترويسة (بكسل) — كل مربع نص في الترويسة على حدة',
    hCompanyName: 'اسم الشركة',
    hTagline: 'الموقع / الشعار النصي',
    hContact: 'معلومات التواصل',
    hDocTitle: 'عنوان المستند',
    hMeta: 'أسطر الرقم / التاريخ',
    compactHeader: 'ترويسة مدمجة',
    compactHeaderHint: ' — انقل معلومات التواصل أسفل الموقع الإلكتروني، بجانب الشعار، لتوفير المساحة العمودية',
    partySection: 'قسم "أُعد لـ / صادر عن"',
    partyLabels: 'التسميات (بكسل)',
    partyNames: 'الأسماء (بكسل)',
    partyDetails: 'التفاصيل (بكسل)',
    headerGap: 'المسافة بعد الترويسة (بكسل)',
    headerGapHint: 'تتحكم المسافة بعد الترويسة في الفراغ بين شريط الترويسة وهذا القسم (0 = متلاصقان).',
    resetTheme: 'إعادة التعيين إلى السمة الافتراضية',
    currencyDefaults: 'العملة والإعدادات الافتراضية',
    defaultCurrency: 'العملة الافتراضية',
    pdfMargin: 'هامش PDF ‏/ Word (سم)',
    defaultTerms: 'الشروط والأحكام الافتراضية',
    termsPh: 'مثال: يُستحق الدفع خلال 30 يومًا. تُطبّق غرامة تأخير 1.5٪ شهريًا على الحسابات المتأخرة…',
    bankDetails: 'التفاصيل البنكية / الدفع',
    bankDetailsIntro: 'ستظهر هذه التفاصيل تلقائيًا في جميع الفواتير والإيصالات.',
    bankName: 'اسم البنك',
    accountNumber: 'رقم الحساب',
    accountHolder: 'اسم صاحب الحساب',
    signatory: 'المخوّل بالتوقيع',
    signatoryName: 'الاسم',
    designation: 'المسمى الوظيفي',
    signatureImage: 'صورة التوقيع الرقمي',
    noSignature: 'لا يوجد توقيع',
    removeSignature: 'إزالة التوقيع',
    pngRecommended: 'يُفضّل ملف PNG بخلفية شفافة.',
    saveAll: 'حفظ جميع الإعدادات',
    errorSaving: 'خطأ أثناء الحفظ',
  },
  subscription: {
    title: 'الاشتراك',
    subtitle: 'إدارة خطة Invio والفوترة',
    currentPlan: 'الخطة الحالية',
    freeTrial: 'تجربة مجانية',
    none: 'لا يوجد',
    trialEndsIn: 'تنتهي التجربة خلال',
    days: '{d} يوم',
    renewsOn: 'يتجدد في',
    billingHistory: 'سجل الفواتير',
    subscribedSince: 'مشترك منذ',
    totalPaid: 'إجمالي المدفوع',
    payDate: 'التاريخ',
    payAmount: 'المبلغ',
    payPlan: 'الخطة',
    payStatus: 'الحالة',
    payReceipt: 'الإيصال',
    paySucceeded: 'مدفوع',
    payFailed: 'فشل',
    pastDueMsg: 'فشل الدفع. يرجى تحديث وسيلة الدفع لمواصلة استخدام Invio.',
    manageBilling: 'إدارة الفوترة ←',
    opening: 'جاري الفتح…',
    portalUnavailable: 'البوابة غير متاحة',
    activated: 'تم تفعيل الاشتراك! جاري التحديث…',
    checkoutCancelled: 'تم إلغاء عملية الدفع',
    readyToContinue: 'هل أنت مستعد لمواصلة استخدام Invio؟',
    getInTouch: 'تواصل معنا',
    tailorPlan: 'سنصمم خطة تناسب عملك. تواصل معنا وسنساعدك على البدء.',
    talkToUs: 'تحدث إلينا',
    whatsapp: 'واتساب',
    choosePlan: 'اختر خطة',
    upgradeAnytime: 'قم بالترقية في أي وقت',
    subscribeMonthly: 'اشترك شهريًا',
    subscribeYearly: 'اشترك سنويًا',
    redirecting: 'جاري التحويل…',
    checkoutFailed: 'فشلت عملية الدفع. يرجى المحاولة مرة أخرى.',
    securePayment: 'دفع آمن عبر Stripe. يمكنك الإلغاء في أي وقت.',
    needCustom: 'هل تحتاج إلى خطة مخصصة؟',
  },
  password: {
    length: '8 أحرف على الأقل',
    lowercase: 'حرف صغير واحد',
    uppercase: 'حرف كبير واحد',
    digit: 'رقم واحد',
    symbol: 'رمز واحد (مثل ! @ # $ %)',
    common: 'ليست كلمة مرور شائعة الاستخدام',
    weak: 'ضعيفة',
    fair: 'مقبولة',
    strong: 'قوية',
    excellent: 'ممتازة',
    meetsAll: 'تفي بجميع المتطلبات',
  },
  server: {
    emailRegistered: 'البريد الإلكتروني مسجل بالفعل',
    invalidCredentials: 'البريد الإلكتروني أو كلمة المرور غير صحيحة',
    accountDeactivated: 'تم تعطيل حسابك. تواصل مع المسؤول.',
    missingToken: 'رمز التحقق مفقود',
    verifyInvalid: 'رابط التحقق غير صالح أو مستخدم من قبل',
    verifyExpired: 'انتهت صلاحية رابط التحقق. يرجى طلب رابط جديد.',
    emailRequired: 'البريد الإلكتروني مطلوب',
    resetInvalid: 'رابط إعادة تعيين كلمة المرور هذا غير صالح أو تم استخدامه بالفعل.',
    resetExpired: 'انتهت صلاحية رابط إعادة تعيين كلمة المرور. يرجى طلب رابط جديد.',
    tooManyRequests: 'محاولات كثيرة جداً. يرجى الانتظار بضع دقائق ثم المحاولة مرة أخرى.',
    currentPasswordRequired: 'كلمة المرور الحالية مطلوبة',
    currentPasswordWrong: 'كلمة المرور الحالية غير صحيحة',
    weakPassword: 'كلمة المرور لا تفي بمتطلبات الأمان.',
    aiPaidOnly: 'ميزات الذكاء الاصطناعي تتطلب اشتراكًا مدفوعًا. قم بالترقية لاستخدام الاستيراد الذكي.',
    missingFileData: 'بيانات الملف مفقودة.',
    fileTooLarge: 'حجم الملف يتجاوز حد 25 ميجابايت.',
    itemNotFound: 'الصنف غير موجود',
    clientNotFound: 'العميل غير موجود',
    docNotFound: 'المستند غير موجود',
    noStripeCustomer: 'لا يوجد حساب فوترة مرتبط بعد. اشترك أولاً.',
    alreadySubscribed: 'لديك اشتراك بالفعل. استخدم إدارة الفوترة لتغييره.',
    supportFieldsRequired: 'الموضوع والرسالة مطلوبان',
    caseNotFound: 'الحالة غير موجودة',
    caseClosed: 'هذه الحالة مغلقة. يرجى فتح حالة جديدة.',
    caseReopenExpired: 'لا يمكن إعادة فتح هذه الحالة. يرجى فتح حالة جديدة.',
    paymentNotPayable: 'يمكن تسجيل الدفعات على الفواتير فقط.',
    paymentCancelledDoc: 'هذا المستند ملغى.',
    paymentInvalidAmount: 'أدخل مبلغ دفعة أكبر من صفر.',
    paymentExceedsBalance: 'الدفعة أكبر من الرصيد المستحق.',
    paymentInvalidDate: 'تاريخ الدفع غير صالح.',
    paymentNotFound: 'الدفعة غير موجودة.',
    statusPaidByPayments: 'هذا المستند مدفوع بالكامل. احذف دفعة لتغيير حالته.',
    shareNotFound: 'هذا الرابط لم يعد متاحًا.',
    shareCannotRespond: 'لم يعد بالإمكان الرد على عرض السعر هذا.',
    shareBadAction: 'اختر القبول أو الرفض.',
    shareNameRequired: 'يرجى إدخال اسمك.',
    sendNotConfigured: 'لم يتم إعداد إرسال البريد على هذا الخادم.',
    sendVerifyFirst: 'تحقق من بريدك الإلكتروني قبل إرسال المستندات.',
    sendNoRecipient: 'أدخل البريد الإلكتروني للمستلم.',
    sendTooManyRecipients: '5 عناوين كحد أقصى لكل حقل.',
    sendBadRecipient: 'أحد عناوين البريد الإلكتروني غير صالح.',
    sendDailyLimit: 'تم بلوغ الحد اليومي للبريد. حاول مرة أخرى غدًا.',
    sendFailed: 'تعذر إرسال البريد.',
    recurringBadFrequency: 'تكرار غير معروف.',
    recurringNoStart: 'اختر تاريخ أول فاتورة.',
    recurringEndBeforeStart: 'تاريخ الانتهاء يسبق أول فاتورة.',
    recurringNotInvoice: 'يمكن تكرار الفواتير فقط.',
    recurringNotFound: 'الجدول غير موجود.',
    einvoiceLocked: 'هذا المستند فاتورة إلكترونية مُرسلة إلى LHDN ولا يمكن تغييره. ألغِ الفاتورة (خلال 72 ساعة) أو أصدر إشعارًا دائنًا.',
    einvDisabled: 'الفوترة الإلكترونية غير مفعّلة.',
    einvNoCredentials: 'لم يتم تعيين Client ID وSecret لـ MyInvois.',
    einvBadCredentials: 'رفض MyInvois بيانات Client ID / Secret. تحقق منها ومن البيئة.',
    einvUnreachable: 'تعذر الوصول إلى MyInvois. حاول مرة أخرى.',
    einvNotReady: 'بعض البيانات ناقصة.',
    einvAlreadySubmitted: 'أُرسل هذا المستند إلى LHDN مسبقًا.',
    einvSubmitFailed: 'لم يقبل MyInvois الإرسال.',
    einvRejected: 'رفض MyInvois المستند.',
    einvNotValid: 'يمكن إلغاء الفاتورة المُتحقق منها فقط.',
    einvCancelReason: 'اذكر سبب الإلغاء.',
    einvCancelWindow: 'انقضت مهلة الإلغاء (72 ساعة) — أصدر إشعارًا دائنًا بدلًا من ذلك.',
    einvCancelFailed: 'لم يُلغِ MyInvois المستند.',
    einvApiError: 'أعاد MyInvois خطأ. حاول مرة أخرى.',
  },
  reset: {
    checking: 'جاري التحقق من رابط إعادة التعيين…',
    title: 'اختر كلمة مرور جديدة',
    intro: 'أدخل كلمة مرور جديدة لحسابك في Invio.',
    newPassword: 'كلمة المرور الجديدة',
    confirmPassword: 'تأكيد كلمة المرور الجديدة',
    mismatch: 'كلمتا المرور غير متطابقتين.',
    submit: 'إعادة تعيين كلمة المرور',
    failedGeneric: 'تعذّرت إعادة تعيين كلمة المرور. يرجى المحاولة مرة أخرى.',
    success: 'تم تحديث كلمة المرور',
    successBody: 'يمكنك الآن تسجيل الدخول بكلمة المرور الجديدة. تم تسجيل الخروج من الأجهزة الأخرى.',
    invalidTitle: 'رابط إعادة التعيين غير صالح',
    invalidGeneric: 'رابط إعادة تعيين كلمة المرور هذا غير صالح أو منتهي الصلاحية.',
    requestNew: 'طلب رابط جديد',
  },
  verify: {
    verifying: 'جاري التحقق من بريدك الإلكتروني…',
    justAMoment: 'لحظة من فضلك.',
    verified: 'تم التحقق من البريد الإلكتروني',
    confirmed: 'تم تأكيده. يمكنك الآن استخدام Invio بشكل طبيعي.',
    continue: 'المتابعة إلى Invio ←',
    failed: 'فشل التحقق',
    failedGeneric: 'رابط التحقق غير صالح أو منتهي الصلاحية.',
    alreadySignedIn: 'سجّلت الدخول بالفعل؟ يمكنك طلب رسالة تحقق جديدة من الشريط أعلى أي صفحة.',
  },
  support: {
    title: 'الدعم',
    subtitle: 'افتح حالة وسنتواصل معك',
    newCase: 'حالة جديدة',
    empty: 'لا توجد حالات دعم بعد. لديك مشكلة أو سؤال؟ افتح حالة وسنساعدك.',
    created: 'تم فتح الحالة {n} — سنتواصل معك قريبًا',
    createFailed: 'تعذّر فتح الحالة',
    subject: 'الموضوع *',
    subjectPh: 'ملخص قصير للمشكلة',
    category: 'الفئة',
    priority: 'الأولوية',
    message: 'اشرح المشكلة *',
    messagePh: 'ماذا حدث؟ ماذا كنت تتوقع؟ خطوات إعادة إنتاج المشكلة تساعد كثيرًا…',
    attachments: 'لقطات شاشة (اختياري، حتى 3 صور)',
    attachTooLarge: 'الصورة كبيرة جدًا (الحد الأقصى 2 ميجابايت)',
    submit: 'فتح الحالة',
    yourTurn: 'بانتظار ردك',
    allCases: 'كل الحالات',
    cat: { billing: 'الفوترة والاشتراك', bug: 'خلل / شيء لا يعمل', question: 'سؤال / كيفية الاستخدام', feature: 'اقتراح ميزة', other: 'أخرى' },
    status: { open: 'مفتوحة', in_progress: 'قيد المعالجة', waiting_on_user: 'بانتظار ردك', resolved: 'تم الحل', closed: 'مغلقة' },
    prio: { low: 'منخفضة', normal: 'عادية', high: 'عالية' },
    resolvedTitle: 'تم وضع علامة "تم الحل" على هذه الحالة',
    resolvedAsk: 'هل حُلّت مشكلتك؟',
    confirmClose: 'نعم، أغلق الحالة',
    reopen: 'لا، أعد فتحها',
    you: 'أنت',
    supportTeam: 'دعم Invio',
    caseClosed: 'هذه الحالة مغلقة. هل تحتاج مزيدًا من المساعدة؟',
    replyPh: 'اكتب ردًا…',
    send: 'إرسال',
    sendFailed: 'تعذّر الإرسال',
    closedMsg: 'تم إغلاق الحالة — شكرًا لك!',
    reopenedMsg: 'أُعيد فتح الحالة — سنراجعها مرة أخرى',
  },
  notif: {
    title: 'الإشعارات',
    empty: 'لا توجد إشعارات بعد',
    justNow: 'الآن',
    minutesAgo: 'قبل {n} دقيقة',
    hoursAgo: 'قبل {n} ساعة',
    daysAgo: 'قبل {n} يوم',
    trialExtended: 'تم تمديد تجربتك {days} يومًا. 🎉',
    trialReminder: 'تنتهي تجربتك خلال {days} يوم. اشترك للحفاظ على الوصول.',
    trialGrace: 'انتهت تجربتك — تبقى {days} يوم من فترة السماح قبل قفل الحساب.',
    paymentFailed: 'فشل الدفع — حدّث وسيلة الدفع خلال {days} يوم للحفاظ على الوصول.',
    paymentRecovered: 'تم استرداد الدفع — اشتراكك نشط مرة أخرى.',
    paymentReceipt: 'تم استلام الدفعة: {amount} — شكرًا لك! تم إرسال الإيصال إلى بريدك الإلكتروني.',
    supportReply: 'ردّ فريق الدعم على حالتك {n}.',
    supportResolved: 'تم حل حالة الدعم الخاصة بك {n}.',
    supportCase: 'حالة دعم جديدة {n} من {from}.',
    supportUserReply: 'ردّ {from} على حالة الدعم {n}.',
    docViewed: 'قام {client} بفتح {n}',
    quoteAccepted: 'قبل {client} عرض السعر {n}',
    quoteRejected: 'رفض {client} عرض السعر {n}',
    recurringIssued: 'تم إصدار الفاتورة المتكررة {n} لـ {client}',
    recurringIssuedSent: 'تم إصدار الفاتورة المتكررة {n} وإرسالها بالبريد إلى {client}',
    recurringIssuedError: 'تم إصدار الفاتورة المتكررة {n} لكن لم تُرسل بالبريد: {error}',
    invoiceOverdue: 'الفاتورة {n} أصبحت متأخرة',
    invoicesOverdue: 'أصبحت {count} فواتير متأخرة',
    einvoiceValid: 'تحققت LHDN من الفاتورة {n}',
    einvoiceInvalid: 'رفضت LHDN الفاتورة {n} — افتحها لمعرفة السبب',
  },
  impersonate: {
    banner: 'جلسة دعم من المسؤول',
    return: 'العودة إلى المسؤول',
  },
  payments: {
    title: 'المدفوعات',
    record: 'تسجيل دفعة',
    none: 'لم يتم تسجيل أي دفعات بعد.',
    paid: 'المبلغ المدفوع',
    balance: 'الرصيد المستحق',
    balanceShort: 'الرصيد {amount}',
    amount: 'المبلغ',
    date: 'تاريخ الدفع',
    method: 'طريقة الدفع',
    reference: 'رقم المرجع',
    referencePh: 'مثال: مرجع التحويل البنكي',
    note: 'ملاحظة',
    notePh: 'مثال: دفعة مقدمة 30٪',
    payFull: 'كامل الرصيد',
    save: 'حفظ الدفعة',
    recorded: 'تم تسجيل الدفعة',
    removed: 'تم حذف الدفعة',
    confirmRemove: 'هل تريد حذف هذه الدفعة؟',
    failed: 'تعذر حفظ الدفعة',
    fullyPaid: 'مدفوع بالكامل',
    m_bank_transfer: 'تحويل بنكي',
    m_cash: 'نقدًا',
    m_card: 'بطاقة',
    m_cheque: 'شيك',
    m_ewallet: 'محفظة إلكترونية',
    m_online: 'دفع عبر الإنترنت',
    m_other: 'أخرى',
  },
  statement: {
    title: 'كشف حساب',
    button: 'كشف حساب',
    back: 'العملاء',
    from: 'من',
    to: 'إلى',
    currency: 'العملة',
    thisMonth: 'هذا الشهر',
    lastMonth: 'الشهر الماضي',
    thisYear: 'هذه السنة',
    downloadPdf: 'تنزيل PDF',
    opening: 'الرصيد الافتتاحي',
    closing: 'الرصيد الختامي',
    invoiced: 'المفوتر',
    paid: 'المدفوع',
    credited: 'المقيد دائنًا',
    paidCredit: 'مدفوع / دائن',
    balanceDue: 'الرصيد المستحق',
    balance: 'الرصيد',
    date: 'التاريخ',
    details: 'التفاصيل',
    k_invoice: 'فاتورة',
    k_payment: 'دفعة مستلمة',
    k_credit_note: 'إشعار دائن',
    due: 'مستحق في {date}',
    empty: 'لا توجد معاملات في هذه الفترة.',
    aging: 'المستحقات حسب العمر',
    current: 'حالي',
    days: '{range} يوم',
    loadFailed: 'تعذر تحميل كشف الحساب',
  },
  share: {
    send: 'إرسال',
    title: 'إرسال {n}',
    cardTitle: 'المشاركة',
    linkTitle: 'رابط عام',
    linkHelp: 'يمكن لأي شخص لديه هذا الرابط عرض المستند وتنزيل ملف PDF دون تسجيل الدخول.',
    createLink: 'إنشاء رابط',
    copy: 'نسخ',
    copied: 'تم نسخ الرابط',
    open: 'فتح',
    disable: 'إيقاف الرابط',
    disableConfirm: 'هل تريد إيقاف هذا الرابط؟ لن يتمكن من لديه الرابط من فتحه بعد الآن.',
    disabled: 'تم إيقاف الرابط',
    whatsapp: 'مشاركة عبر واتساب',
    whatsappText: 'مرحبًا {name}، إليك {type} رقم {n} من {company}:\n{url}',
    emailTitle: 'إرسال بالبريد إلى العميل',
    to: 'إلى',
    cc: 'نسخة (اختياري)',
    ccPh: 'accounts@client.com, you@company.com',
    subject: 'الموضوع',
    message: 'الرسالة',
    defaultSubject: '{type} رقم {n} من {company}',
    defaultMessage: 'مرحبًا {name}،\n\nتجدون مرفقًا {type} رقم {n}.\n\nشكرًا لكم،\n{sender}',
    attachPdf: 'إرفاق ملف PDF',
    includeLink: 'تضمين زر "عرض عبر الإنترنت"',
    replyNote: 'يُرسل باسم شركتك. تصل الردود إلى {email}.',
    sendEmail: 'إرسال البريد',
    sending: 'جارٍ الإرسال…',
    sent: 'تم إرسال البريد إلى {to}',
    sendFailed: 'تعذر إرسال البريد',
    linkFailed: 'تعذر إنشاء الرابط',
    linkOn: 'الرابط العام مفعّل',
    linkOff: 'لم تتم المشاركة بعد',
    views: 'تمت المشاهدة {n} مرة',
    notViewed: 'لم تتم المشاهدة بعد',
    lastViewed: 'آخر مشاهدة {date}',
    lastEmailed: 'أُرسل بالبريد إلى {to} في {date}',
    responded_accepted: 'قبله {name} في {date}',
    responded_rejected: 'رفضه {name} في {date}',
    reminderSubject: 'تذكير: {type} رقم {n} من {company}',
    reminderMessage: 'مرحبًا {name}،\n\nهذا تذكير ودي بأن {type} رقم {n} لا تزال بانتظار الدفع. ربما تم إغفالها فقط.\n\nإذا كنت قد دفعت بالفعل، يرجى تجاهل هذه الرسالة — وشكرًا لك.\n\nمع التحية،\n{sender}',
  },
  publicDoc: {
    loading: 'جارٍ تحميل المستند…',
    notFoundTitle: 'هذا الرابط لم يعد متاحًا',
    notFoundBody: 'ربما قام المرسل بإيقافه. يرجى طلب رابط جديد منه.',
    from: 'من',
    to: 'إلى',
    issued: 'تاريخ الإصدار',
    due: 'تاريخ الاستحقاق',
    validUntil: 'صالح حتى',
    downloadPdf: 'تنزيل PDF',
    preparing: 'جارٍ التحضير…',
    pdfFailed: 'تعذر تحضير ملف PDF. يرجى المحاولة مرة أخرى.',
    amountDue: 'المبلغ المستحق',
    paidInFull: 'مدفوع بالكامل — شكرًا لكم!',
    howToPay: 'طريقة الدفع',
    acceptTitle: 'الرد على عرض السعر هذا',
    yourName: 'اسمك الكامل',
    accept: 'قبول عرض السعر',
    decline: 'رفض',
    declineConfirm: 'هل تريد رفض عرض السعر هذا؟',
    acceptNote: 'بالقبول، فإنك تؤكد العناصر والأسعار والشروط الموضحة أعلاه.',
    accepted: 'قبله {name} في {date}',
    rejected: 'رفضه {name} في {date}',
    respondFailed: 'تعذر حفظ ردك. يرجى المحاولة مرة أخرى.',
    poweredBy: 'أُرسل عبر Invio — أنشئ فواتيرك مجانًا لمدة 30 يومًا',
    regNo: 'رقم التسجيل',
    taxNo: 'الرقم الضريبي',
  },
  recurring: {
    title: 'الفواتير المتكررة',
    subtitle: 'فواتير تصدر تلقائيًا وفق جدول زمني',
    empty: 'لا توجد فواتير متكررة بعد. افتح أي فاتورة واختر «اجعلها متكررة».',
    goInvoices: 'الانتقال إلى الفواتير',
    make: 'اجعلها متكررة',
    modalTitle: 'تكرار {n}',
    modalIntro: 'سيصدر Invio فاتورة جديدة بالعناصر نفسها وفق هذا الجدول. لن تتغير هذه الفاتورة نفسها.',
    frequency: 'التكرار',
    every: 'كل',
    f_weekly: 'أسبوع',
    f_monthly: 'شهر',
    f_quarterly: 'ربع سنة',
    f_yearly: 'سنة',
    firstInvoice: 'أول فاتورة في',
    endDate: 'تاريخ الانتهاء (اختياري)',
    dueDays: 'استحقاق الدفع بعد (أيام)',
    autoSend: 'إرسال كل فاتورة إلى العميل بالبريد تلقائيًا',
    autoSendHelp: 'إيقاف: تُنشأ الفواتير كمسودات لتراجعها وترسلها بنفسك.',
    noClientEmail: 'لا يملك هذا العميل بريدًا إلكترونيًا — أضف واحدًا لاستخدام الإرسال التلقائي.',
    create: 'بدء الجدول',
    created: 'تم إعداد الفاتورة المتكررة. التالية: {date}',
    saved: 'تم تحديث الجدول',
    failed: 'تعذر حفظ الجدول',
    thClient: 'العميل / الفاتورة',
    thAmount: 'المبلغ',
    thSchedule: 'الجدول',
    thNext: 'الفاتورة التالية',
    thStatus: 'الحالة',
    summary: 'كل {n} {unit}',
    issued: 'تم إصدار {n}',
    last: 'الأخيرة: {n}',
    until: 'حتى {date}',
    autoSendOn: 'إرسال تلقائي',
    asDraft: 'ينشئ مسودات',
    s_active: 'نشط',
    s_paused: 'متوقف مؤقتًا',
    s_ended: 'منتهٍ',
    pause: 'إيقاف مؤقت',
    resume: 'استئناف',
    runNow: 'إصدار الآن',
    runConfirm: 'هل تريد إصدار الفاتورة التالية الآن؟',
    ran: 'تم إصدار {n}',
    deleteConfirm: 'حذف هذا الجدول؟ سيتم الاحتفاظ بالفواتير الصادرة.',
    deleted: 'تم حذف الجدول',
    lastError: 'آخر تشغيل: {msg}',
    fromSchedule: 'صادرة عن جدول متكرر',
    basedOn: 'استنادًا إلى {n}',
  },
  reminders: {
    title: 'تذكيرات الدفع',
    intro: 'يمكن لـ Invio إرسال بريد تلقائي إلى عملائك عندما يقترب موعد استحقاق الفاتورة أو تتأخر. تُرسل الرسائل باسم شركتك مع رابط للفاتورة، وتصلك الردود مباشرة. تُعلَّم الفواتير دائمًا كمتأخرة تلقائيًا سواء كانت التذكيرات مفعّلة أم لا.',
    enable: 'إرسال تذكيرات الدفع إلى العملاء تلقائيًا',
    before: 'أيام قبل تاريخ الاستحقاق (0 = إيقاف)',
    after: 'أيام بعد تاريخ الاستحقاق',
    afterHelp: 'مفصولة بفواصل، مثال: 1, 7, 14',
    needsEmail: 'تُرسل التذكيرات فقط للفواتير التي يملك عميلها بريدًا إلكترونيًا. يمكنك استثناء فاتورة واحدة من صفحتها.',
    docToggle: 'لا تذكيرات تلقائية لهذه الفاتورة',
    docSent: 'التذكيرات المرسلة: {n}',
    updated: 'تم حفظ تفضيل التذكير',
  },
  onboarding: {
    title: 'ابدأ مع Invio',
    subtitle: 'أربع خطوات سريعة لإصدار أول فاتورة تحمل شعارك.',
    progress: 'اكتمل {done} من {total}',
    dismiss: 'إخفاء',
    s_company: 'أضف بيانات شركتك',
    d_company: 'يظهر اسمك وشعارك على كل مستند.',
    s_client: 'أضف عميلك الأول',
    d_client: 'احفظ بياناته مرة واحدة وأعد استخدامها في كل عرض سعر وفاتورة.',
    s_document: 'أنشئ أول فاتورة أو عرض سعر',
    d_document: 'اختر عميلًا، أضف العناصر، وانتهيت. صدّر إلى PDF أو Word في أي وقت.',
    s_sent: 'أرسلها إلى عميلك',
    d_sent: 'بالبريد مع إرفاق PDF، أو عبر واتساب، أو كرابط — وشاهد متى يفتحها.',
    companyName: 'اسم الشركة',
    phone: 'الهاتف',
    logo: 'الشعار (اختياري)',
    saveCompany: 'حفظ',
    moreSettings: 'المزيد من الإعدادات',
    companySaved: 'تم حفظ بيانات الشركة',
    addClient: 'إضافة عميل',
    newInvoice: 'فاتورة جديدة',
    newQuotation: 'عرض سعر جديد',
    openDocs: 'فتح مستنداتي',
    sampleTitle: 'تريد فقط أن ترى كيف تبدو؟',
    sampleBody: 'أنشئ فاتورة نموذجية بنقرة واحدة وافتحها كملف PDF بهوية شركتك. تبقى مسودة — احذفها متى شئت.',
    sampleCreate: 'إنشاء فاتورة نموذجية',
    sampleOpen: 'فتح الفاتورة النموذجية',
    sampleFailed: 'تعذر إنشاء النموذج',
    sampleBanner: 'هذه فاتورة نموذجية. جرّب زرّي PDF والإرسال ثم احذفها — إنها مسودة ولا تؤثر على أرقامك.',
  },
  einv: {
    title: 'الفاتورة الإلكترونية LHDN (MyInvois)',
    subtitle: 'أرسل الفواتير والإشعارات الدائنة إلى LHDN للتحقق منها مباشرة من Invio',
    back: 'الإعدادات',
    settingsIntro: 'تفرض ماليزيا الفوترة الإلكترونية على مراحل. اربط حسابك في MyInvois وسيرسل Invio فواتيرك إلى LHDN ويضع رمز QR للتحقق على ملف PDF.',
    open: 'إعداد الفاتورة الإلكترونية',
    statusOn: 'مفعّل — {env}',
    statusOff: 'غير مُعدّ',
    stepsTitle: 'طريقة الربط',
    step1: 'سجّل الدخول إلى بوابة MyInvois (ابدأ ببيئة الاختبار: preprod.myinvois.hasil.gov.my).',
    step2: 'افتح ملف دافع الضرائب ← Representatives ← Register ERP، وسمّه «Invio».',
    step3: 'انسخ Client ID وClient Secret الظاهرين (يظهر السر مرة واحدة فقط) والصقهما أدناه.',
    step4: 'اختبر الاتصال، وأرسل فاتورة تجريبية في بيئة الاختبار، ثم انتقل إلى Production بمفاتيح الإنتاج.',
    enable: 'استخدام الفوترة الإلكترونية LHDN',
    connection: 'اتصال MyInvois',
    environment: 'البيئة',
    sandbox: 'بيئة الاختبار',
    production: 'الإنتاج (فواتير حقيقية)',
    clientId: 'Client ID',
    clientSecret: 'Client Secret',
    secretSaved: 'محفوظ — اتركه فارغًا للإبقاء عليه',
    secretNote: 'يُخزَّن مشفّرًا. لن يُعرض مجددًا ولن يُعاد إلى متصفحك.',
    test: 'اختبار الاتصال',
    testing: 'جارٍ الاختبار…',
    testOk: 'تم الاتصال بـ MyInvois ({env}).',
    testTinValid: 'رقم TIN ورقم التسجيل يطابقان سجلات LHDN.',
    testTinInvalid: 'تم الاتصال، لكن LHDN لا يتعرف على هذا المزيج من TIN ورقم التسجيل.',
    saveFirst: 'احفظ الإعدادات أولًا ثم اختبر.',
    supplier: 'بياناتك الضريبية',
    supplierNote: 'اسم الشركة والعنوان والمدينة والبريد تؤخذ من الإعدادات الرئيسية.',
    tin: 'TIN (رقم التعريف الضريبي)',
    idType: 'نوع الهوية',
    id_BRN: 'رقم تسجيل النشاط (BRN)',
    id_NRIC: 'الهوية الوطنية (NRIC)',
    id_PASSPORT: 'جواز السفر',
    id_ARMY: 'هوية عسكرية',
    idValue: 'رقم الهوية / التسجيل',
    sstNo: 'رقم تسجيل SST (إن وُجد)',
    ttxNo: 'رقم ضريبة السياحة (إن وُجد)',
    msic: 'رمز MSIC (5 أرقام)',
    msicHelp: 'تجده في ملفك ببوابة MyInvois أو في قائمة MSIC لدى LHDN.',
    activity: 'وصف النشاط التجاري',
    postcode: 'الرمز البريدي',
    state: 'الولاية',
    chooseState: 'اختر ولاية…',
    phone: 'رقم الاتصال',
    defaults: 'الإعدادات الافتراضية لكل فاتورة',
    classification: 'تصنيف ما تبيعه',
    classificationHelp: '«022 Others» يناسب معظم الأنشطة. يمكنك تغييره لكل فاتورة عند الإرسال.',
    taxType: 'الضريبة التي تفرضها (عندما تتضمن الفاتورة ضريبة)',
    taxNone: 'لا أفرض ضريبة',
    tax_01: 'ضريبة المبيعات',
    tax_02: 'ضريبة الخدمات',
    save: 'حفظ إعدادات الفاتورة الإلكترونية',
    saved: 'تم حفظ الإعدادات',
    versionNote: 'يرسل Invio الإصدار 1.0 من المستند الذي تقبله LHDN دون شهادة رقمية. سيُدعم الإصدار 1.1 (الموقّع رقميًا) عندما توقف LHDN الإصدار 1.0.',
    clientSection: 'بيانات الفاتورة الإلكترونية (LHDN)',
    clientSectionHelp: 'مطلوبة فقط إذا كنت ترسل فواتير إلكترونية لهذا العميل.',
    buyerTin: 'رقم TIN للعميل',
    generalPublic: 'بدون TIN — فرد ماليزي',
    generalForeign: 'بدون TIN — مشترٍ أجنبي',
    country: 'الدولة (رمز من 3 أحرف)',
    checkTin: 'التحقق لدى LHDN',
    tinValid: 'تتعرف LHDN على هذا TIN والهوية.',
    tinInvalid: 'لا تتعرف LHDN على هذا المزيج من TIN والهوية.',
    card: 'الفاتورة الإلكترونية LHDN',
    st_none: 'لم تُرسل',
    st_submitted: 'أُرسلت — بانتظار LHDN',
    st_valid: 'تم التحقق من LHDN',
    st_invalid: 'رفضتها LHDN',
    st_cancelled: 'أُلغيت الفاتورة الإلكترونية',
    submit: 'إرسال إلى LHDN',
    resubmit: 'صحّح وأعد الإرسال',
    submitting: 'جارٍ الإرسال…',
    refresh: 'تحقق من الحالة',
    viewOnPortal: 'عرض في MyInvois',
    uuid: 'UUID',
    validatedOn: 'تم التحقق {date}',
    sandboxBadge: 'اختبار',
    locked: 'هذا المستند مقفل: ما تحققت منه LHDN يجب أن يبقى مطابقًا لما لدى عميلك. لتغييره، ألغِ الفاتورة الإلكترونية (خلال 72 ساعة) أو أصدر إشعارًا دائنًا.',
    modalTitle: 'إرسال {n} إلى LHDN',
    modalIntro: 'تتحقق LHDN من الفاتورة خلال ثوانٍ. بعد التحقق يُقفل المستند ويحمل ملف PDF رمز QR من LHDN.',
    sandboxWarning: 'وضع الاختبار: هذا إرسال تجريبي بلا أثر قانوني.',
    productionWarning: 'الإنتاج: هذه فاتورة حقيقية تُبلَّغ إلى LHDN.',
    fixFirst: 'صحّح ما يلي أولًا:',
    fixInSettings: 'إعدادات الفاتورة الإلكترونية',
    fixInClient: 'تعديل العميل',
    exchangeRate: 'سعر الصرف: 1 {cur} = ؟ MYR',
    notEnabled: 'لم يتم إعداد الفوترة الإلكترونية بعد.',
    done_valid: 'تم التحقق من LHDN ✓',
    done_submitted: 'أُرسلت. ما زالت LHDN تتحقق — راجع الحالة بعد قليل.',
    done_invalid: 'رفضت LHDN الفاتورة — راجع الأسباب في المستند.',
    failed: 'تعذر الإرسال إلى LHDN',
    cancel: 'إلغاء الفاتورة الإلكترونية',
    cancelTitle: 'إلغاء الفاتورة الإلكترونية',
    cancelIntro: 'تسمح LHDN بالإلغاء خلال 72 ساعة من التحقق. بعدها أصدر إشعارًا دائنًا. تُخطر LHDN عميلك.',
    cancelReason: 'السبب',
    cancelReasonPh: 'مثال: مبلغ خاطئ',
    cancelled: 'أُلغيت الفاتورة الإلكترونية',
    publicBadge: 'فاتورة إلكترونية مُتحقق منها من LHDN',
    publicVerify: 'تحقق في MyInvois',
  },
  einvP: {
    einvType: 'يمكن إرسال الفواتير والإشعارات الدائنة فقط كفواتير إلكترونية.',
    einvCancelledDoc: 'هذا المستند ملغى.',
    einvNoItems: 'لا يحتوي المستند على عناصر.',
    einvItemDescription: 'يحتاج كل عنصر إلى وصف.',
    einvSupplierTin: 'رقم TIN الخاص بك مفقود أو غير صالح.',
    einvSupplierId: 'رقم تسجيل نشاطك / هويتك مفقود.',
    einvMsic: 'رمز MSIC المكوّن من 5 أرقام مفقود.',
    einvActivity: 'وصف نشاطك التجاري مفقود.',
    einvSupplierName: 'اسم شركتك مفقود (الإعدادات).',
    einvSupplierAddress: 'عنوان شركتك مفقود (الإعدادات).',
    einvSupplierCity: 'مدينة شركتك مفقودة (الإعدادات).',
    einvSupplierState: 'اختر ولايتك.',
    einvSupplierPhone: 'رقم الاتصال الخاص بك مفقود.',
    einvNoClient: 'اربط هذا المستند بعميل.',
    einvBuyerTin: 'رقم TIN للعميل مفقود (استخدم TIN العام لمن لا يملك رقمًا).',
    einvBuyerId: 'رقم تسجيل / هوية العميل مفقود.',
    einvBuyerAddress: 'عنوان العميل مفقود.',
    einvBuyerCity: 'مدينة العميل مفقودة.',
    einvBuyerState: 'اختر ولاية العميل.',
    einvBuyerCountry: 'يجب أن تكون دولة العميل رمزًا من 3 أحرف (مثل MYS).',
    einvBuyerPhone: 'رقم هاتف العميل مفقود.',
    einvExchangeRate: 'أدخل سعر الصرف إلى MYR.',
    einvTaxType: 'اختر ما إذا كانت ضريبتك ضريبة مبيعات أم ضريبة خدمات.',
    einvSstNo: 'رقم تسجيل SST مطلوب عندما تفرض ضريبة.',
    einvOriginal: 'يجب إنشاء الإشعار الدائن من فاتورة تم التحقق منها إلكترونيًا.',
  },
  common: {
    save: 'حفظ',
    saving: 'جاري الحفظ…',
    cancel: 'إلغاء',
    edit: 'تعديل',
    delete: 'حذف',
    view: 'عرض',
    loading: 'جاري التحميل…',
    welcome: 'يومًا سعيدًا',
    overview: 'هذه نظرة عامة على أعمالك',
    language: 'اللغة',
  },
};
export default ar;
